import { combineReducers } from 'redux';

import {
    REQUEST_ENTERPRISE_CARD_PAY,
    SUCCESS_ENTERPRISE_CARD_PAY,
    FAILURE_ENTERPRISE_CARD_PAY,
    REQUEST_ENTERPRISE_CARD_DETAILS,
    SUCCESS_ENTERPRISE_CARD_DETAILS,
    FAILURE_ENTERPRISE_CARD_DETAILS
} from './constants';

const submit = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_ENTERPRISE_CARD_PAY:
            return action.response.payload.confirmed;
        case REQUEST_ENTERPRISE_CARD_PAY:
        case FAILURE_ENTERPRISE_CARD_PAY:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ENTERPRISE_CARD_PAY:
            return true;
        case FAILURE_ENTERPRISE_CARD_PAY:
        case SUCCESS_ENTERPRISE_CARD_PAY:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ENTERPRISE_CARD_PAY:
            return action.response.message;
        case REQUEST_ENTERPRISE_CARD_PAY:
        case SUCCESS_ENTERPRISE_CARD_PAY:
            return '';
        default:
            return state;
    }
};

const details = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_ENTERPRISE_CARD_DETAILS:
            return action.response.payload;
        case REQUEST_ENTERPRISE_CARD_DETAILS:
        case FAILURE_ENTERPRISE_CARD_DETAILS:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    submit,
    fetching,
    error,
    details
});



// WEBPACK FOOTER //
// ./src/services/enterprisecard/reducer.js